
export class FileService {
  getRandomParam() {
    return '?t=' + this.getRandomHash();
  }

  private getRandomHash() {
    return (Math.random() + 1).toString(36).substring(7);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/base/file.service.ts